import styled from 'styled-components';
import {
  Flex,
  SVG,
  utils,
} from 'web-styled';

import {
  Button,
} from 'web-components';

export const Exercise = styled(Flex).attrs({
  column: true,
})`
  margin-top: 30px;
  width: 100%;
  flex-shrink: 0;
`;

export const ExerciseHeader = styled(Flex).attrs({
  spacing: 10,
  align: 'center',
  justify: 'space-between',
})`
  padding: 20px 70px 20px 25px;
  background-color: #fafafa;
  border: 1px solid #ededed;
  border-radius: 10px 10px 0 0;
  width: 100%;
`;

export const NumberContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  clickable: true,
})`
  color: #fff;
  text-transform: uppercase;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 9px;
  ${utils.exerciseColor};
`;

export const ExerciseName = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: 14px;
  margin-left: 15px;
`;

export const ExerciseFooter = styled(Flex).attrs({
  align: 'center',
})`
  padding: 15px 0px 15px 25px;
  border-radius: 0 0 10px 10px;
  border: 1px solid #ededed;
  background-color: #fafafa;
  width: 100%;
  color: ${props => props.theme.colors.primary};
`;

export const AddResults = styled(Flex).attrs({
  spacing: 10,
  align: 'center',
})`
  color: rgb(102, 102, 102);
  font-size: 12px;
  text-transform: capitalize;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    width: 30,
    height: 30,
    stroke: props.theme.colors.primary,
  }),
)``;

export const ConfirmResultButton = styled(Button).attrs({
  type: 'submit',
  appearance: 'link',
})`
  width: 30px;
  height: 30px;
  margin-top: 22px;
  flex-shrink: 0;
  opacity: 0.8;

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

export const ClearResutsButton = styled(Button).attrs({
  icon: 'fas fa-backspace',
  iconSize: '20px',
  appearance: 'link',
})`
  color: ${props => (props.disabled ? '#bcc5c8' : props.theme.colors.danger)};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  margin-top: 29px;
  flex-shrink: 0;
  &:hover,
  &:focus {
    color: #bcc5c8;
  }
`;

export const InputWrapper = styled(Flex).attrs({
  align: 'center',
  spacing: 2,
})`
  border: 1px solid #ededed;
  border-radius: 5px;
  max-width: 70px;

  input {
    height: 40px;
    padding: 10px;
    border: none;

    &:focus,
    &:active,
    &:hover {
      border: none;
      outline: none;
      box-shadow: none;
      text-decoration: none;
    }
  }
`;

export const ResultLabel = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: 14px;
  padding: 5px;
`;

export const AddResult = styled(Flex).attrs({
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 30px;
  border: 1px solid #ededed;
  border-bottom: 0;
  transition: all 0.3s ease-in-out;
`;

export const Results = styled(Flex).attrs({
  justify: 'center',
  align: 'flex-end',
  column: true,
})`
  padding: 15px;
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
  width: 100%;
`;

export const Result = styled(Flex).attrs({
  align: 'center',
  justify: 'flex-end',
  spacing: 10,
})`
  position: relative;
  cursor: pointer;
  padding: 10px 25px;
  width: 100%;

  .trashcan {
    visibility: hidden;
    margin-top: 5px;
  }

  &:hover .trashcan {
    visibility: visible;
  }
`;

export const PersonalBest = styled(Flex).attrs({
  align: 'center',
  spacing: 5,
})`
  color: ${props => props.theme.colors.primary};
  margin: 5px 0 5px 0;
  padding: 7px 5px 7px 12px;
  width: 130px;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }

  ${props => props.selected && `
    color: #fff;
    border-radius: 10px;
    background-color: ${props.theme.colors.primary};
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);

    path {
      fill: #fff !important;
    }
  `};
`;

export const PersonalBestIcon = styled(SVG.PersonalBest).attrs(
  props => ({
    fill: props.theme.colors.primary,
    width: 16,
    height: 16,
  }),
)``;
